import { AfterViewChecked, AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { UserDetailsDto } from '@shared/service-proxies/service-proxies';
import { fadeInExpandOnEnterAnimation } from 'angular-animations';
import * as _ from 'lodash';
import { OverlayPanel } from 'primeng/overlaypanel';

@Component({
    selector: "profile-image-chain",
    templateUrl: "./profile-image-chain.component.html",
    styleUrls: ["./profile-image-chain.component.scss"],
    encapsulation: ViewEncapsulation.None,
    animations: [fadeInExpandOnEnterAnimation()]
})
export class ProfileImageChainComponent implements OnInit {
    @Input() userDetails: UserDetailsDto[];
    @Input() size: string;
    @Input() interactive: boolean;
    @Input() showConsolidatedViewLink: boolean;
    @Output() onUserSelect = new EventEmitter<UserDetailsDto>();
    @Output() onConsolidatedViewClick = new EventEmitter<UserDetailsDto[]>();
    @Output() viewAll = new EventEmitter<UserDetailsDto[]>();
    @ViewChild("profileImageChainContainer") profileImageChainContainer: ElementRef;
    @ViewChild("op") op: OverlayPanel;
    viewAllHtml: string;
    viewAllPanelVisible = false;
    viewAllPanel: boolean;
    zIndex = 3;

    constructor() {}

    getShiftValue(index: number) {
        if (index > 0) {
            return `${index * 8}px`;
        } else {
            return "0px";
        }
    }

    ngOnInit(): void {
    }

    onScroll() {
        this.zIndex = 2147483647; // Maximum value for z-index
      }

    enlargeDiv(index: number) {
        (this.profileImageChainContainer.nativeElement as HTMLElement).querySelectorAll("div.image-div").forEach((el, i) => {
            if (i === index) el.classList.add("enlarge-image-div");
        });
    }

    shrinkDiv(index: number) {
        (this.profileImageChainContainer.nativeElement as HTMLElement).querySelectorAll("div.image-div").forEach((el, i) => {
            if (i === index) el.classList.remove("enlarge-image-div");
        });
    }

    showUserDetails(index: number) {
        if (this.interactive !== false) this.onUserSelect.emit(this.userDetails[index]);
    }

    showUserDetailsFromExtraList(index: number, event: Event) {
        if (event) event.stopPropagation();
        if (this.interactive !== false) {
            this.onUserSelect.emit(this.userDetails.slice(3)[index]);
            this.viewAllPanelVisible = false;
        }
    }

    showConsolidatedView() {
        if (this.interactive !== false) this.onConsolidatedViewClick.emit(this.userDetails);
    }

    viewAllUsers() {
        if (this.interactive !== false) this.viewAll.emit(this.userDetails);
    }

    getIconShiftValue(userDetails: UserDetailsDto[]) {
        if (this.userDetails.length === 1) return "-9px";
        if (this.userDetails.length === 2) return "-2px";
        if (this.userDetails.length === 3) return "6px";
        return `16px`;
    }


    hideViewAllPanel() {
        setTimeout(() => {
            if (this.viewAllPanel) return;
            this.viewAllPanelVisible = false;
        }, 500);
    }
}

